export default __webpack_public_path__ + "static/media/flameEmoji.8af60b41.png";